import { IPricingTypes } from 'types/graphqlTypes'
import { object, string } from 'yup'
import { recursiveInsert } from 'utils/validators'
import {
  IShipperRate,
  IShipperApplication,
  IEquipment,
  ILocation,
  IRate,
  AWARD_TYPE,
  IBulkUploadFormState,
} from '../types/shipperRates'

export interface IValidationErrors {
  awardType?: string
  pickup?: string
  delivery?: string
  shipperApplication?: string
  equipment?: string
  startDate?: string
  rateAmount?: string
  rateType?: string
  volume?: string
  volumeType?: string
  existingAwardId?: string
}

const validateShipper = (shipper?: RecursivePartial<IShipperApplication>) => shipper && shipper.id
const validateEquipment = (equipment?: RecursivePartial<IEquipment>) => equipment && equipment.key
const validateRateAmount = (rate?: RecursivePartial<IRate>) => rate && rate.amount
const validateRateType = (rate?: RecursivePartial<IRate>) => rate && rate.rateTypeKey
const validateLocation = (location?: RecursivePartial<ILocation>) =>
  location && ((location.city && location?.stateCode) || location?.postalCode)
export const validateShipperRate = (
  shipperRate: RecursivePartial<IShipperRate>,
  isEdit: boolean
) => {
  const errors: IValidationErrors = {}

  if (!validateShipper(shipperRate?.shipperApplication)) errors.shipperApplication = 'Required'
  if (!validateEquipment(shipperRate?.equipment)) errors.equipment = 'Required'
  if (!validateRateAmount(shipperRate?.rate) && shipperRate.pricingType !== IPricingTypes.variable)
    errors.rateAmount = 'Required'
  if (!validateRateType(shipperRate?.rate) && shipperRate.pricingType !== IPricingTypes.variable)
    errors.rateType = 'Required'
  if (!validateLocation(shipperRate?.pickup)) errors.pickup = 'Required'
  if (!validateLocation(shipperRate?.delivery)) errors.delivery = 'Required'
  if (!shipperRate.awardType) errors.awardType = 'Required'
  if (!shipperRate.startDate) errors.startDate = 'Required'
  if (shipperRate.isRepricedRate && !isEdit && !shipperRate.existingAwardId)
    errors.existingAwardId = 'Required'

  if (shipperRate.awardType === AWARD_TYPE.primary && !shipperRate.isRepricedRate) {
    if (!shipperRate.volume) errors.volume = 'Required when Award Type is Primary'
    if (!shipperRate.volumeType) errors.volumeType = 'Required when Award Type is Primary'
  }

  return errors
}

const bulkUploadSchema = {
  file: object().required('Must upload a file'),
  email: string().required('Must enter an email address'),
}

export const validateBulkUploadForm = (form: RecursivePartial<IBulkUploadFormState>) => {
  try {
    return object().shape(bulkUploadSchema).validateSync(form, { abortEarly: false })
  } catch (errs) {
    const validationMessages = errs.inner.reduce(recursiveInsert, {})
    throw validationMessages
  }
}
